import React from "react";

const ReservationBanner: React.FC = () => {
  const handleReservation = () => {
    window.open("https://resy.com/cities/edison-nj/venues/house-of-bombay");
  };
  return (
    <section className="reservation-section">
      <div className="hero-border">
        <div className="reservation-container">
          <div className="reservation-image-container">
            <picture>
              <source media="(max-width:768px)" srcSet="/mumbai_m.webp" />
              <source media="(min-width:768px)" srcSet="/mumbai_d.webp" />
              <img
                src="/mumbai_d.webp"
                alt="Food"
                className="reservation-image"
              />
            </picture>
          </div>
          {/* <div className="overlay"></div> */}
          <div className="reservation-text">
            <h2>
              Pull up a chair.
              <br />
              The city is already here.
            </h2>
          </div>

          <button
            className="reservation-button"
            onClick={() => handleReservation()}
          >
            MAKE RESERVATION
          </button>
        </div>
      </div>
    </section>
  );
};

export default ReservationBanner;
